// extracted by mini-css-extract-plugin
export default {"Form":"EditionMotifConsultation_Form__WGMmF","FormFocus":"EditionMotifConsultation_FormFocus__C3PSO","IconeHistorique":"EditionMotifConsultation_IconeHistorique__AYaH1"};